import { getColorStyle } from "@common/color";
import {
  convertCurrentDateWithTime,
} from "@common/date-helpers";
import { concatString, formatText } from "@common/text-helpers";
import { getValue } from "@utils/lodash";
import React from "react";

function EmailLogsTable(props: any) {
  const { emailLogsList, onRowClick } = props;
  
  // Helper function to safely format text
  const safeFormatText = (text: any) => {
    if (typeof text === 'string') {
      return formatText(text);
    }
    return text || '';
  };

  // Helper function to safely get color style
  const safeGetColorStyle = (status: any) => {
    if (typeof status === 'boolean') {
      return getColorStyle(status ? "active" : "inactive");
    }
    if (typeof status === 'string') {
      return getColorStyle(status);
    }
    return {};
  };

  // Helper function to format recipients
  const formatRecipients = (recipients: any) => {
    if (Array.isArray(recipients)) {
      return recipients.join(", ");
    }
    if (typeof recipients === 'string') {
      return recipients;
    }
    return "";
  };

  // Helper function to format status
  const formatStatus = (status: any) => {
    if (typeof status === 'boolean') {
      return status ? "Sent" : "Failed";
    }
    if (typeof status === 'string') {
      return safeFormatText(status);
    }
    return "Unknown";
  };

  return (
    <div>
      <table className="datatable_table">
        <thead className="datatable_table_thead">
          <th className="datatable_table_th" style={{ width: "400px", textAlign: "left" }}>
            <h6 className="">Subject</h6>
          </th>
          <th className="datatable_table_th" style={{ width: "300px" }}>
            <h6 className="">Recipients</h6>
          </th>
          <th className="datatable_table_th" style={{ width: "200px" }}>
            <h6 className="">Sent on</h6>
          </th>
          <th className="datatable_table_th" style={{ width: "150px" }}>
            <h6 className="">Status</h6>
          </th>
        </thead>
        <tbody className="datatable_table_tbody">
          {getValue(emailLogsList, `length`, 0) > 0 &&
            emailLogsList.map((bodyObj: object, index: number) => {
              const subject = getValue(bodyObj, `subject`, "");
              const recipients = getValue(bodyObj, `recipients`, []);
              const createdAt = getValue(bodyObj, `createdAt`, null);
              const status = getValue(bodyObj, `status`, false);

              return (
                <tr 
                  key={index} 
                  className="datatable_table_tr"
                  onClick={() => onRowClick && onRowClick(bodyObj)}
                  style={{ cursor: 'pointer' }}
                >
                  <td className="datatable_table_td text-left" style={{ textAlign: "left" }}>
                    <h6 className="color_primary header_text__14">
                      {concatString(subject || "", 50)}
                    </h6>
                  </td>
                  <td className="datatable_table_td">
                    <h6 className="">
                      {concatString(formatRecipients(recipients), 40)}
                    </h6>
                  </td>
                  <td className="datatable_table_td">
                    <h6 className="">
                      {createdAt
                        ? convertCurrentDateWithTime(createdAt)
                        : "-"}
                    </h6>
                  </td>
                  <td className="datatable_table_td">
                    <h6
                      className=""
                      style={safeGetColorStyle(status)}
                    >
                      {formatStatus(status)}
                    </h6>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}

export default EmailLogsTable; 